/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientCompany } from './';
import {
    ClientCompanyFromJSON,
    ClientCompanyFromJSONTyped,
    ClientCompanyToJSON,
} from './';
import type { Currency } from './';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './';
import type { FreelancerFeeTypeResource } from './';
import {
    FreelancerFeeTypeResourceFromJSON,
    FreelancerFeeTypeResourceFromJSONTyped,
    FreelancerFeeTypeResourceToJSON,
} from './';
import type { InvoicingModeType } from './';
import {
    InvoicingModeTypeFromJSON,
    InvoicingModeTypeFromJSONTyped,
    InvoicingModeTypeToJSON,
} from './';
import type { QuoteContextResourceClientTerms } from './';
import {
    QuoteContextResourceClientTermsFromJSON,
    QuoteContextResourceClientTermsFromJSONTyped,
    QuoteContextResourceClientTermsToJSON,
} from './';
import type { QuoteContextResourceProjectTerms } from './';
import {
    QuoteContextResourceProjectTermsFromJSON,
    QuoteContextResourceProjectTermsFromJSONTyped,
    QuoteContextResourceProjectTermsToJSON,
} from './';
import type { Tax } from './';
import {
    TaxFromJSON,
    TaxFromJSONTyped,
    TaxToJSON,
} from './';
import type { TaxStatus } from './';
import {
    TaxStatusFromJSON,
    TaxStatusFromJSONTyped,
    TaxStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface QuoteContextResource
 */
export interface QuoteContextResource {
    /**
     * 
     * @type {ClientCompany}
     * @memberof QuoteContextResource
     */
    clientCompany: ClientCompany;
    /**
     * 
     * @type {boolean}
     * @memberof QuoteContextResource
     */
    isPrePayment: boolean;
    /**
     * 
     * @type {QuoteContextResourceProjectTerms}
     * @memberof QuoteContextResource
     */
    projectTerms?: QuoteContextResourceProjectTerms;
    /**
     * 
     * @type {QuoteContextResourceClientTerms}
     * @memberof QuoteContextResource
     */
    clientTerms?: QuoteContextResourceClientTerms;
    /**
     * 
     * @type {Array<Tax>}
     * @memberof QuoteContextResource
     */
    taxes: Array<Tax>;
    /**
     * 
     * @type {TaxStatus}
     * @memberof QuoteContextResource
     */
    taxStatus?: TaxStatus;
    /**
     * 
     * @type {string}
     * @memberof QuoteContextResource
     */
    maltBillingEntityName?: string;
    /**
     * 
     * @type {InvoicingModeType}
     * @memberof QuoteContextResource
     */
    invoicingModeType: InvoicingModeType;
    /**
     * 
     * @type {Currency}
     * @memberof QuoteContextResource
     */
    clientCurrency: Currency;
    /**
     * 
     * @type {Currency}
     * @memberof QuoteContextResource
     */
    freelancerCurrency: Currency;
    /**
     * 
     * @type {number}
     * @memberof QuoteContextResource
     */
    freelancerFeePercent: number;
    /**
     * 
     * @type {number}
     * @memberof QuoteContextResource
     */
    freelancerFeeTaxPercent: number;
    /**
     * 
     * @type {FreelancerFeeTypeResource}
     * @memberof QuoteContextResource
     */
    freelancerFeeType: FreelancerFeeTypeResource;
    /**
     * [BILL-2546] Whether to display the informational freelancer service fee banner on the quote page (temporary, feature-flagged).
     * @type {boolean}
     * @memberof QuoteContextResource
     */
    showFreelancerServiceFeeBanner: boolean;
    /**
     * 
     * @type {string}
     * @memberof QuoteContextResource
     */
    briefId?: string;
    /**
     * 
     * @type {string}
     * @memberof QuoteContextResource
     */
    projectCorrelationId?: string;
    /**
     * 
     * @type {string}
     * @memberof QuoteContextResource
     */
    repatriationOpportunityId?: string;
}

/**
 * Check if a given object implements the QuoteContextResource interface.
 */
export function instanceOfQuoteContextResource(value: object): value is QuoteContextResource {
    if (!('clientCompany' in value) || value['clientCompany'] === undefined) return false;
    if (!('isPrePayment' in value) || value['isPrePayment'] === undefined) return false;
    if (!('taxes' in value) || value['taxes'] === undefined) return false;
    if (!('invoicingModeType' in value) || value['invoicingModeType'] === undefined) return false;
    if (!('clientCurrency' in value) || value['clientCurrency'] === undefined) return false;
    if (!('freelancerCurrency' in value) || value['freelancerCurrency'] === undefined) return false;
    if (!('freelancerFeePercent' in value) || value['freelancerFeePercent'] === undefined) return false;
    if (!('freelancerFeeTaxPercent' in value) || value['freelancerFeeTaxPercent'] === undefined) return false;
    if (!('freelancerFeeType' in value) || value['freelancerFeeType'] === undefined) return false;
    if (!('showFreelancerServiceFeeBanner' in value) || value['showFreelancerServiceFeeBanner'] === undefined) return false;
    return true;
}

export function QuoteContextResourceFromJSON(json: any): QuoteContextResource {
    return QuoteContextResourceFromJSONTyped(json, false);
}

export function QuoteContextResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteContextResource {
    if (json == null) {
        return json;
    }
    return {
        
        'clientCompany': ClientCompanyFromJSON(json['clientCompany']),
        'isPrePayment': json['isPrePayment'],
        'projectTerms': json['projectTerms'] == null ? undefined : QuoteContextResourceProjectTermsFromJSON(json['projectTerms']),
        'clientTerms': json['clientTerms'] == null ? undefined : QuoteContextResourceClientTermsFromJSON(json['clientTerms']),
        'taxes': ((json['taxes'] as Array<any>).map(TaxFromJSON)),
        'taxStatus': json['taxStatus'] == null ? undefined : TaxStatusFromJSON(json['taxStatus']),
        'maltBillingEntityName': json['maltBillingEntityName'] == null ? undefined : json['maltBillingEntityName'],
        'invoicingModeType': InvoicingModeTypeFromJSON(json['invoicingModeType']),
        'clientCurrency': CurrencyFromJSON(json['clientCurrency']),
        'freelancerCurrency': CurrencyFromJSON(json['freelancerCurrency']),
        'freelancerFeePercent': json['freelancerFeePercent'],
        'freelancerFeeTaxPercent': json['freelancerFeeTaxPercent'],
        'freelancerFeeType': FreelancerFeeTypeResourceFromJSON(json['freelancerFeeType']),
        'showFreelancerServiceFeeBanner': json['showFreelancerServiceFeeBanner'],
        'briefId': json['briefId'] == null ? undefined : json['briefId'],
        'projectCorrelationId': json['projectCorrelationId'] == null ? undefined : json['projectCorrelationId'],
        'repatriationOpportunityId': json['repatriationOpportunityId'] == null ? undefined : json['repatriationOpportunityId'],
    };
}

export function QuoteContextResourceToJSON(value?: QuoteContextResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clientCompany': ClientCompanyToJSON(value['clientCompany']),
        'isPrePayment': value['isPrePayment'],
        'projectTerms': QuoteContextResourceProjectTermsToJSON(value['projectTerms']),
        'clientTerms': QuoteContextResourceClientTermsToJSON(value['clientTerms']),
        'taxes': ((value['taxes'] as Array<any>).map((v) => TaxToJSON(v))),
        'taxStatus': TaxStatusToJSON(value['taxStatus']),
        'maltBillingEntityName': value['maltBillingEntityName'],
        'invoicingModeType': InvoicingModeTypeToJSON(value['invoicingModeType']),
        'clientCurrency': CurrencyToJSON(value['clientCurrency']),
        'freelancerCurrency': CurrencyToJSON(value['freelancerCurrency']),
        'freelancerFeePercent': value['freelancerFeePercent'],
        'freelancerFeeTaxPercent': value['freelancerFeeTaxPercent'],
        'freelancerFeeType': FreelancerFeeTypeResourceToJSON(value['freelancerFeeType']),
        'showFreelancerServiceFeeBanner': value['showFreelancerServiceFeeBanner'],
        'briefId': value['briefId'],
        'projectCorrelationId': value['projectCorrelationId'],
        'repatriationOpportunityId': value['repatriationOpportunityId'],
    };
}

